import React, { useState } from 'react';

const scholars = [
  "Survani Sinha", "Roshini Selvakumar", "Abdullah Mohammed", "Ram Sumedh Besta",
  "Peerzada Shahmeer Alum", "Alastair Go", "C. Tibet Pozam", "Sofia Kazintseva",
  "Oechsel Theo", "Srishanth Ravi", "Muhammadyahyo", "Jordyn Szczesniak", "Klair Tan",
  "Elif Bilge Kas", "Aidan Wong", "Anshi Elizabeth Thomas", "Samaira Khan", "Siyeong Park",
  "Jinghan Zhang", "Alyson Henderson", "Claire Lily Huang", "Vyom Uppar",
  "Miguel Christopher Mok", "Deren Toker", "Tianyu Li", "Harshil Jegan", "Utsav Saroha",
  "Rithvik Sai Reddy Kambham", "Jiexi Pan", "Marie-Jose Rohayem", "Yeeun Choi",
  "Vihaan Gupta", "Tapasya Illuri", "Hedy Tang", "Aldric Benala", "Atul Ganesh",
  "Jacquelyn Inocencio", "Siri Pulakandam", "Anoushka Swaminathan", "Srichandra Pallerla",
  "Roaran Katelan", "Anusha Sudheer", "Chunghyun Kawata", "Suhaan Khan",
  "Jobanjot Singh Madhok", "Laksan Mohan", "Reyo Apollo Schwilk Khan", "Morgan Gruber",
  "Eesha Vanamala", "Nimeesha Komatireddy", "Michelle Diep", "Feride Ada Senturk",
  "Iraj Gupta", "Yara Aziz", "Rohini Vedam", "Morgan Duran", "Sydney Yu", "Sumedha Saha",
  "Paridhi Goel", "Avika Taneja", "Deeksha Shashidhar", "Arjan Gavin Singh Waraich",
  "Briana Codrescu", "Yena Kim", "Lasya Pannala", "Aadhavan Veerendra", "Andrew Rahana",
  "Aarthi Palaniappan", "Rehan Raj", "Brooke Foley", "Arya Verma", "Veer Chopra",
  "William Flaxenburg", "Ashley Mahajan", "Norah Majed Altamimi", "Darshika Domma",
  "Tanya Yong", "Aryana Hou", "Sathwika Prasad", "Aishwarya Kamineni", "Collin Lu",
  "Tsz Chai Alan Liu", "Haidar Jamal Haidar Haidar", "Aaron Sethi", "Caden Chen",
  "Sarah Hassan", "Saanvi Desu", "Bhavani Manohar", "Nandana Pai", "Sia Mehta",
  "Melanie Xu", "Mila Marie Arce Barredo", "Rafa Chen", "Alyssa Perez",
  "Kiana Marie P. Lazaro", "Srinidhi Kakarla", "Aric Yang", "Joy Yixing Zhou",
  "Arjun Uthaman", "Srishti Agrawal", "Marium Khan", "Ananya Satish", "Zuzanna Talarczyk",
  "Dhyeya Patel", "Adam Zhang", "Dylan Siraj", "Darren Peter Kim", "Shreyash Gupta",
  "Jaiveer Bhatia", "Jiale Huang", "Naol Meskela", "Myesha Nayanathara Godakumbura",
  "Moksha Lashkari", "Ananya Arjariya", "Vicki Zhong", "Aryan Golechha",
  "Melinda Ng Siu Han", "Aanya Sanyal", "Matthew Jin", "Alina Selivanova", "Hannah Yu",
  "Aadi Waghray", "Mrinmayee Joshi", "Siddhant Ramananda Naik", "Kate Yelensky",
  "Vedangi Wagh", "Kaitlyn Zhou", "Jiyoon Lee", "Sanjana Senthil", "Evelyn Shi",
  "Hemangi Madaan", "Wenshu Wang", "Stepan Galstyan", "Suraj Swaminathan", "Tavishi Sinha",
  "Reyansh Mohan Lal", "Kausthubha Naraparaju", "Jophy Lin", "Theodore Mui",
  "Ainsley Bosman", "Matthew Young Chi", "Ishaan Dabhade", "Akchara Mukunthu Deepak Babu",
  "Snehansh Reddy Bachala", "Srisaran Sivakumar"
];

function DistinguishedScholar() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNames = scholars.filter(name =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          March 20, 2025
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '16px'
        }}>
          2025 Distinguished Scholars
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7' }}>
          <strong>Congratulations to our Distinguished Scholars!</strong> These students represent the top 20% of all IRO participants.
        </p>
      </div>

      {/* Stats */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '40px',
        flexWrap: 'wrap'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            {scholars.length}
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Distinguished Scholars</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            Top 20%
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Of All Participants</p>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search for a name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#004d99'}
          onBlur={(e) => e.target.style.borderColor = '#e8eef3'}
        />
      </div>

      {/* Names Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: '12px'
      }}>
        {filteredNames.map((name, index) => (
          <div key={index} style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '14px 18px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
            border: '1px solid #e8eef3',
            fontSize: '0.95rem',
            color: '#1a1a2e',
            fontWeight: '500'
          }}>
            {name}
          </div>
        ))}
      </div>

      {filteredNames.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '40px' }}>
          No results found for "{searchTerm}"
        </p>
      )}
    </div>
  );
}

export default DistinguishedScholar;
